import { EPLEDGE_REQUEST_BOOK, EPLEDGE_REQUEST_BOOK_ERROR, EPLEDGE_REQUEST_BOOK_HIDE_ERROR, EPLEDGE_REQUEST_BOOK_START_LOADER, EPLEDGE_REQUEST_BOOK_STOP_LOADER, } from "../interface/iEpledgeRequestBook";
const initState = {
    data: [],
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const epledgeRequestBookReducer = (state = initState, action) => {
    switch (action.type) {
        case EPLEDGE_REQUEST_BOOK:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case EPLEDGE_REQUEST_BOOK_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case EPLEDGE_REQUEST_BOOK_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case EPLEDGE_REQUEST_BOOK_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case EPLEDGE_REQUEST_BOOK_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default epledgeRequestBookReducer;
